/**
 *  Users.jsx
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

// system
import React, { Component } from "react";

// template
import { Grid, Tabs, Tab } from "react-bootstrap";

// redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { saveUsers, clearUsers } from "../../actions/users";

// components
import UserList from "./UserList.jsx";

// style
import "./style.css";
import { getUserPhotoUrl } from "../../utils/index.js";

// global
var firebase = require("../../firebase");

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      users: [],
      quantityUsers: 0,
    };
  }

  componentWillMount() {
    const { users } = this.props;
    document.title = "Security Care | Usuários";

    //if (!Object.keys(users).length > 0) {
    this.getUsers();
    /*} else {
            this.save(users);
        }*/
  }

  getUsers = () => {
    const { saveUsers } = this.props;

    firebase.database
      .ref("users")
      .orderByChild("createdAt")
      .once("value")
      .then((snap) => {
        saveUsers(snap.val());
        this.save(snap.val());
      });
  };

  save = (snap) => {
    let quantityUsers = 0,
      user,
      users = [];

    for (let key in snap) {
      user = snap[key];
      user["key"] = key;
      user["name"] = user.name ? user.name : "Não informado";
      user["city"] = user.city ? user.city : "Não informado";
      user["state"] = user.state ? user.state : "Não informado";
      user["phone"] = user.phone ? user.phone : "Não informado";
      user["photoUrl"] = getUserPhotoUrl(user.key);

      quantityUsers += 1;
      users.push(user);
      if (user.phone.includes("919851250")) {
        console.log(user);
      }
    }

    this.setState({ quantityUsers, users });
  };

  render() {
    const { quantityUsers, users } = this.state;

    return (
      <div className="content bg-content">
        <Grid fluid>
          <Tabs defaultActiveKey="0" id="uncontrolled-tab-example">
            <Tab eventKey="0" title={`USUÁRIOS (${quantityUsers})`}>
              <UserList users={users} />
            </Tab>
          </Tabs>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({
  users: store.users.users,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ saveUsers, clearUsers }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/views/Users/Users.jsx